import { useState } from "react";
import { Link } from "react-router-dom";

function AdminListings() {

  const [listings, setListings] =
    useState(
      JSON.parse(
        localStorage.getItem(
          "buySellListings"
        )
      ) || []
    );


  const pendingListings =
    listings.filter(
      (listing) =>
        listing.status === "pending"
    );


  const approveListing =
    async (id) => {

      const listing =
        listings.find(
          (item) =>
            item.id === id
        );

      if (!listing) return;


      const updated =
        listings.map(
          (item) =>
            item.id === id
              ? {
                  ...item,
                  status:
                    "approved",
                  rejectionReason:
                    "",
                }
              : item
        );


      localStorage.setItem(
        "buySellListings",
        JSON.stringify(updated)
      );

      setListings(updated);


      try {

        const response =
          await fetch(
            "/api/email/approval",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify({
                  email:
                    listing.email,

                  name:
                    listing.name,
                }),
            }
          );


        const data =
          await response.json();


        if (response.ok) {

          alert(
            "Հայտարարությունը հաստատվեց և email-ը ուղարկվեց։"
          );

        } else {

          alert(
            "Հայտարարությունը հաստատվեց, բայց email-ը չուղարկվեց։\n" +
            data.message
          );

        }

      } catch (error) {

        console.error(
          "APPROVAL EMAIL ERROR:",
          error
        );

        alert(
          "Հայտարարությունը հաստատվեց, բայց email-ը չուղարկվեց։"
        );
      }
    };


  const rejectListing =
    async (id) => {

      const reason =
        window.prompt(
          "Գրեք մերժման պատճառը։"
        );


      if (
        !reason ||
        !reason.trim()
      ) {
        return;
      }


      const listing =
        listings.find(
          (item) =>
            item.id === id
        );


      if (!listing) return;


      const updated =
        listings.map(
          (item) =>
            item.id === id
              ? {
                  ...item,
                  status:
                    "rejected",

                  rejectionReason:
                    reason.trim(),
                }
              : item
        );


      localStorage.setItem(
        "buySellListings",
        JSON.stringify(updated)
      );

      setListings(updated);


      try {

        const response =
          await fetch(
            "/api/email/rejection",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify({

                  email:
                    listing.email,

                  name:
                    listing.name,

                  reason:
                    reason.trim(),

                }),
            }
          );


        const data =
          await response.json();


        if (response.ok) {

          alert(
            "Հայտարարությունը մերժվեց և email-ը ուղարկվեց։"
          );

        } else {

          alert(
            "Հայտարարությունը մերժվեց, բայց email-ը չուղարկվեց։\n" +
            data.message
          );

        }

      } catch (error) {

        console.error(
          "REJECTION EMAIL ERROR:",
          error
        );

        alert(
          "Հայտարարությունը մերժվեց, բայց email-ը չուղարկվեց։"
        );
      }

    };


  return (

    <div className="admin-listings-page">

      <div className="container">

        <div className="admin-header">

          <div>

            <span className="admin-label">
              ADMIN PANEL
            </span>

            <h1>
              Հայտարարություններ
            </h1>

            <p>
              Սպասում են հաստատման՝{" "}
              <strong>
                {pendingListings.length}
              </strong>
            </p>

          </div>


          <Link
            to="/"
            className="admin-back"
          >
            ← Կայք
          </Link>

        </div>


        {pendingListings.length === 0 ? (

          <div className="no-listings">

            <div className="empty-icon">
              ✓
            </div>

            <h2>
              Սպասող հայտարարություններ չկան
            </h2>

            <p>
              Նոր հայտարարությունները կհայտնվեն այստեղ։
            </p>

          </div>

        ) : (

          <div className="admin-listings-grid">

            {pendingListings.map(
              (listing) => (

                <div
                  className="admin-listing-card"
                  key={listing.id}
                >

                  <img
                    src={listing.image}
                    alt={listing.name}
                  />


                  <div className="admin-listing-content">

                    <span className="listing-category">
                      {listing.category}
                    </span>

                    <h2>
                      {listing.name}
                    </h2>

                    <h3>
                      {listing.price}
                    </h3>

                    <p>
                      {listing.description}
                    </p>

                    <p>
                      📞 {listing.phone}
                    </p>

                    <p>
                      ✉️ {listing.email}
                    </p>


                    <div className="admin-actions">

                      <button
                        className="approve-button"
                        onClick={() =>
                          approveListing(
                            listing.id
                          )
                        }
                      >
                        ✓ Հաստատել
                      </button>


                      <button
                        className="reject-button"
                        onClick={() =>
                          rejectListing(
                            listing.id
                          )
                        }
                      >
                        ✕ Մերժել
                      </button>

                    </div>

                  </div>

                </div>

              )
            )}

          </div>

        )}

      </div>

    </div>
  );
}

export default AdminListings;